"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_warning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "warning-hi"), /*#__PURE__*/React.createElement("g", {
    id: "d067594b-5206-4633-b1c4-7b0087bc79c4",
    "data-name": "warning-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5bd70ec2-d102-4053-bfd2-e216b5c133fa",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "401ef4ee-4ea6-4440-9776-01c9388b90f9",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ebfc6bc3-6ba3-4079-8b50-57e0f70c044a",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cc8fecac-33eb-414e-872a-b95cb3838c40",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "07fe6e60-d67f-4896-ba0c-dd717193ad9c",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a043bd9d-4ecc-420a-b378-c5731909d70c",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ced27654-5fca-4969-8241-873e25658a43",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6a0976a0-ba3b-4110-b0e2-2c8aec0ac671",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "18c6b726-7b3b-4aaa-9ff2-7f97e0612856",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "95155807-f429-4d76-880b-2abc3d2205c2",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0805d702-e7f9-47c4-94d3-ff3c4c48c79f",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ff458475-b7f8-4009-982e-fc06b34cacba",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ce5b63e6-3a9d-40b4-abda-ecc34ce59b52",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05cb288a-52ee-4447-976c-6f4dadab5166",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "591bb976-0a80-4ae6-aba6-586088b6c0d0",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fd1b16d4-5fff-44d4-ba05-389714eeb43e",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "afe32cb5-37f2-44e5-8ce7-ece7a91bfaa4",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3af4d43a-4784-4432-baaa-acc7b0c7d7f8",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ff66c39d-8e36-4c5d-9ae7-11fda8a60045",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "478d5b7c-b489-4232-9589-2fbf4f7a46fe",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e77eeca7-4f42-4c86-974c-b7f338705223",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dab2fad6-61ba-400c-87f1-02b079f61118",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "31e0870a-bd0c-4231-9874-fafb155bec0b",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dad0e910-d2ff-40c1-aaba-599ed4465799",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "29b06e4d-2cf7-4db5-b7b2-de3607ce8f3b",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4863196d-08f8-43e5-abfc-d20c3b755b86",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7af131b3-47fc-4664-9c07-01f59000daf3",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "dae606ef-c2d3-46b7-84ec-291fcc00078c",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "2d9d7b81-4039-445a-a711-5aec1c0db398",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "7ef1c95c-c3d2-4eab-9d4b-a33cae6bc553",
    "data-name": "<Pfad>",
    d: "M168.43,140.26c8.36,14.8,1.52,27.74-15.2,27.74H38.77c-16.72,0-23.57-12.94-15.2-27.74L80.8,35.05c8.33-14.35,22-15.11,30.41,0Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153.23,166H38.77c-11.42,0-18.23-6-18.74-14.58C19.53,161,26.48,168,38.77,168H153.23c12.29,0,19.24-7,18.74-16.58C171.46,160,164.65,166,153.23,166Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("line", {
    id: "8fa33f84-6d49-47c8-a8fb-6761a6178d8a",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 64,
    x2: 96,
    y2: 120.5,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "8e2b0616-899b-4d6b-80e1-f6674a773258",
    "data-name": "<Pfad>",
    cx: 96,
    cy: 139.89,
    r: 6,
    fill: "#e60000"
  }))))))))))))))))))))))))))))));
}

var _default = ic_warning;
exports.default = _default;